<template>
  <div class="wrapper">
    <admin-title :title="$route.meta.name"></admin-title>
    <div class="header-search">
      <el-form ref="form" inline :model="searchData" label-width="">
        <el-form-item label="资方名称">
          <el-input v-model="searchData.capitalName" size="mini" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="searchData.capitalMobile" size="mini" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="创建日期">
          <el-date-picker
            style="width:230px"
            v-model="timeSlot"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            size="mini"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label=" ">
          <el-button type="primary" icon="el-icon-search" size="mini" @click="getList()">搜索</el-button>
          <el-button type="info" icon="el-icon-refresh" size="mini" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-divider></el-divider>
    <div class="head-btn">
      <el-button
        v-checkbtn="isShowBtn(AUTH_BTN.capital_list_add)"
        type="primary"
        icon="el-icon-plus"
        size="mini"
        @click="handleAdd"
        >创建账号</el-button
      >
      <el-button
        v-checkbtn="isShowBtn(AUTH_BTN.capital_list_export)"
        type="primary"
        icon="el-icon-download"
        size="mini"
        @click="handleExport"
        >导出</el-button
      >
    </div>

    <el-table :data="list" style="width: 100%">
      <el-table-column prop="id" label="ID" min-width="80"> </el-table-column>
      <el-table-column prop="capitalName" label="资方名称" min-width="120"> </el-table-column>
      <el-table-column prop="capitalMobile" label="手机号" min-width="120"> </el-table-column>
      <el-table-column prop="capitalApr" label="年化收益率" min-width="120">
        <template slot-scope="{ row }">{{ row.capitalApr + '%' }}</template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" min-width="160"> </el-table-column>
      <el-table-column prop="availableAmount" label="账户可用余额" min-width="110"> </el-table-column>
      <el-table-column prop="rechargeAmount" label="累计充值金额" min-width="110"> </el-table-column>
      <el-table-column prop="withdrawAmount" label="累计提现金额" min-width="110"> </el-table-column>
      <el-table-column prop="status" label="状态" min-width="100">
        <template slot-scope="{ row }">
          <el-switch
              :disabled="!isShowBtn(AUTH_BTN.capital_list_status)"
              class="switch"
              @change="changeStatus(row)"
              v-model="row['status']"
              :active-value="true"
              :inactive-value="false"
              active-text="启用"
              inactive-text="禁用"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="capitalMobile" label="操作" fixed="right" width="190">
        <template slot-scope="{ row }">
          <el-link
            v-checkbtn="isShowBtn(AUTH_BTN.capital_list_edit)"
            style="margin-right:10px"
            :underline="false"
            type="primary"
            @click="handleEdit(row)"
            >编辑</el-link
          >
          <el-link
            v-checkbtn="isShowBtn(AUTH_BTN.capital_list_recharge)"
            style="margin-right:10px"
            :underline="false"
            type="primary"
            @click="handleRecharge(row)"
            >线下充值</el-link
          >
          <el-link
            v-checkbtn="isShowBtn(AUTH_BTN.capital_list_withdraw)"
            v-if="Number(row.availableAmount) > 0"
            :underline="false"
            type="primary"
            @click="handleWithdraw(row)"
            >代发提现</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <pagination :total="total" :page.sync="searchData.page" :limit.sync="searchData.pageSize" @pagination="getList" />
    <!-- 新增编辑弹窗 -->
    <el-dialog :title="formData.id ? '编辑' : '新增'" :visible.sync="show_edit" width="850px">
      <el-form ref="form" :model="formData" label-width="150px">
        <el-form-item label="资方名称" prop="capitalName" :rules="rules">
          <el-input style="width:250px" v-model="formData.capitalName" clearable placeholder="请输入" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="capitalMobile" :rules="rules">
          <el-input style="width:250px" v-model="formData.capitalMobile" clearable placeholder="请输入" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="年化收益率（%）" prop="capitalApr" :rules="rules">
          <el-input-number style="width:250px" v-model="formData.capitalApr" :controls="false" placeholder="请输入" size="mini"></el-input-number>
          <span>（6% ~ 24%）</span>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="show_edit = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="submit" size="mini">提 交</el-button>
      </div>
    </el-dialog>
    <!-- 线下充值弹窗 -->
    <el-dialog title="线下充值" :visible.sync="show_recharge" width="850px">
      <div class="captial-detail">
        <div class="row">
          <span class="label"> <i class="el-icon-user"></i> 资方名称：</span>
          <span class="value">{{ detail.capitalName }}</span>
        </div>
        <div class="row">
          <span class="label"><i class="el-icon-coin"></i> 账户可用余额：</span>
          <span class="value">{{ detail.availableAmount }}</span>
        </div>
      </div>
      <el-form ref="formRecharge" :model="rechargeData" label-width="80px">
        <el-form-item label="金额：" prop="rechargeAmount" :rules="rules">
          <el-input-number
            style="width:250px"
            v-model="rechargeData.rechargeAmount"
            :precision="2"
            :step="0.01"
            :min="0"
            step-strictly
            size="mini"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input style="width:250px" type="textarea" v-model="rechargeData.remark" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="show_recharge = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="submitRecharge" size="mini">提 交</el-button>
      </div>
    </el-dialog>
    <!-- 代发提现弹窗 -->
    <el-dialog title="代发提现" :visible.sync="show_withdraw" width="850px">
      <div class="withdraw-detail">
        <div class="capital-name">资方【{{ withdrawDetail.capitalName }}】由平台代为发起本次提现</div>
        <div class="amount-panel">
          <div class="left">
            <div class="label">账户可用余额</div>
            <div class="value">￥{{ withdrawDetail.availableAmount }}</div>
          </div>
          <div class="right">
            <div class="row">
              <span class="label">累计充值金额</span>
              <span class="value">￥{{ withdrawDetail.rechargeAmount }}</span>
            </div>
            <div class="row">
              <span class="label">累计提现金额</span>
              <span class="value">￥{{ withdrawDetail.withdrawAmount }}</span>
            </div>
          </div>
        </div>
      </div>
      <el-form ref="formWithdraw" :model="withdrawData" label-position="top" class="withdraw-form">
        <el-form-item label="提现金额" prop="amount" :rules="withdrawRules">
          <div class="amount-field">
            <span class="prefix">￥</span>
            <el-input-number
              style="width:320px"
              v-model="withdrawData.amount"
              :controls="false"
              :precision="2"
              size="mini"
            ></el-input-number>
            <el-link class="withdraw-all" :underline="false" type="primary" @click="handleWithdrawAll">全部提现</el-link>
          </div>
        </el-form-item>
      </el-form>
      <div class="tip">
        <i class="el-icon-warning"></i>
        <span>提交后将生成一条待审批的提现单，需由有审核权限的同事复核通过后执行。</span>
      </div>
      <div slot="footer">
        <el-button @click="show_withdraw = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="submitWithdraw" size="mini">提 交</el-button>
      </div>
    </el-dialog>
    <div style="height:100px"></div>
  </div>
</template>

<script>
import { authBtnMixin } from '@/mixins/authBtnMixin'
import { getListAPI, changeStatusAPI, delAPI, addAPI, editAPI, getDetailAPI, rechargeAPI, withdrawApplyAPI, DownloadAPI } from './api'

export default {
  name: 'List',
  mixins: [authBtnMixin],
  data() {
    return {
      rules: [{ required: true, message: '该项不能为空', trigger: 'blur' }],
      show_edit: false,
      show_recharge: false,
      show_withdraw: false,
      total: 0,
      list: [],
      searchData: {
        page: 1,
        pageSize: 10,
        capitalName: '',
        capitalMobile: '',
        leftCreateDate: '',
        rightCreateDate: ''
      },
      timeSlot: [],
      formData: {
        capitalName: '',
        capitalMobile: '',
        capitalApr: '',
      },
      rechargeData: {
        id: '',
        rechargeAmount: '',
        remark: ''
      },
      detail: {},
      withdrawDetail: {},
      withdrawData: {
        capitalId: '',
        amount: undefined
      },
      withdrawRules: [
        { required: true, message: '请输入提现金额', trigger: 'blur' },
        { validator: this.validateWithdrawAmount, trigger: 'blur' }
      ]
    }
  },

  mounted() {
    this.getList()
  },

  methods: {
    async getList() {
      const { timeSlot } = this
      let params = { ...this.searchData }
      if (timeSlot && timeSlot.length > 0) {
        params.leftCreateDate = timeSlot[0]
        params.rightCreateDate = timeSlot[1]
      }
      const res = await getListAPI(params)
      this.list = res.list || []
      this.total = res.total || 0
    },
    // 删除
    handleDel({ id }) {
      this.$confirm('此操作将永久删除该资方, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delAPI(id).then(() => {
            this.getList()
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
    },
    handleAdd() {
      this.formData = {
        capitalName: '',
        capitalMobile: '',
        capitalApr: '',
      }
      this.show_edit = true
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
    },
    async handleEdit(row) {
      this.show_edit = true
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
      this.formData = await getDetailAPI(row.id)
    },
    // 提交新增编辑
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.formData.id) {
            editAPI(this.formData).then(() => {
              this.$message.success('编辑成功')
              this.getList()
              this.show_edit = false
            })
          } else {
            addAPI(this.formData).then(() => {
              this.$message.success('新增成功')
              this.getList()
              this.show_edit = false
            })
          }
        }
      })
    },
    // 启用/禁用
    changeStatus(row) {
      let { id, status } = row
      let data = { id, status: !!status }
      let statusDesc = status ? '启用' : '禁用'

      this.$confirm(`确定要${statusDesc}该资方吗, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          row.status = !!status
          changeStatusAPI(data).then(() => {
            this.getList()
            this.$message.success('操作成功')
          })
        })
        .catch(() => {
          row.status = !status
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
    },
    reset() {
      this.timeSlot = []
      Object.assign(this._data.searchData, this.$options.data().searchData)
      this.getList()
    },
    // 线下充值按钮
    handleRecharge(row) {
      this.detail = row
      this.rechargeData = {
        id: row.id,
        rechargeAmount: '',
        remark: ''
      }
      this.show_recharge = true
      this.$nextTick(() => {
        this.$refs.formRecharge.resetFields()
      })
    },
    // 提交充值
    submitRecharge() {
      this.$refs.formRecharge.validate(valid => {
        if (valid) {
          rechargeAPI(this.rechargeData).then(() => {
            this.$message.success('充值成功')
            this.getList()
            this.show_recharge = false
          })
        }
      })
    },
    // 代发提现按钮
    async handleWithdraw(row) {
      const detail = await getDetailAPI(row.id)
      this.withdrawDetail = detail || {}
      this.withdrawData = {
        capitalId: row.id,
        amount: undefined
      }
      this.show_withdraw = true
      this.$nextTick(() => {
        this.$refs.formWithdraw.resetFields()
      })
    },
    // 提现金额校验：必填、大于 0、不超过账户可用余额
    validateWithdrawAmount(rule, value, callback) {
      if (value === '' || value === null || value === undefined) {
        callback(new Error('请输入提现金额'))
      } else if (Number(value) <= 0) {
        callback(new Error('提现金额必须大于 0'))
      } else if (Number(value) > Number(this.withdrawDetail.availableAmount || 0)) {
        callback(new Error('提现金额不能超过账户可用余额'))
      } else {
        callback()
      }
    },
    // 全部提现：将账户可用余额填入提现金额输入框
    handleWithdrawAll() {
      this.withdrawData.amount = Number(this.withdrawDetail.availableAmount || 0)
      this.$nextTick(() => {
        this.$refs.formWithdraw.validateField('amount')
      })
    },
    // 提交代发提现
    submitWithdraw() {
      this.$refs.formWithdraw.validate(valid => {
        if (valid) {
          withdrawApplyAPI(this.withdrawData).then(() => {
            this.$message.success('提交成功')
            this.getList()
            this.show_withdraw = false
          })
        }
      })
    },
    handleExport() {
      const { capitalName, capitalMobile } = this.searchData
      const { timeSlot } = this
      let params = { capitalName, capitalMobile }
      if (timeSlot && timeSlot.length > 0) {
        params.leftCreateDate = timeSlot[0]
        params.rightCreateDate = timeSlot[1]
      }
      DownloadAPI(params)
    },
    // 序号自增--方法
    indexMethod(index) {
      // 拿到页码
      const currentPage = this.searchData.page
      // 拿到每页记录条数
      const pageSize = this.searchData.pageSize
      // 根据值进行计算返回
      return index + 1 + (currentPage - 1) * pageSize
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper /deep/ {
  width: 100%;
  .el-dialog {
    .el-dialog__body {
      padding-top: 10px;
    }
  }
  .el-divider--horizontal {
    margin: 0 0 20px;
  }
  .head-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .el-form {
    .el-form-item {
      margin-right: 25px;
    }
  }
  .captial-detail {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding-left: 20px;
    .row {
      display: flex;
      align-items: center;
      margin-right: 40px;
      .label {
        display: flex;
        align-items: center;
        i {
          margin-right: 5px;
        }
      }
      .value {
        font-weight: 600;
      }
    }
  }
  .withdraw-detail {
    .capital-name {
      font-size: 15px;
      font-weight: 600;
      color: #303133;
      margin-bottom: 16px;
    }
    .amount-panel {
      display: flex;
      align-items: center;
      padding: 16px 24px;
      margin-bottom: 20px;
      background: #f7f9fc;
      border-radius: 4px;
      .left {
        flex: 1;
        padding-right: 32px;
        border-right: 1px solid #e4e7ed;
        .label {
          font-size: 13px;
          color: #909399;
          margin-bottom: 8px;
        }
        .value {
          font-size: 22px;
          font-weight: 600;
          color: #409eff;
        }
      }
      .right {
        flex: 1;
        padding-left: 32px;
        .row {
          display: flex;
          align-items: center;
          font-size: 13px;
          & + .row {
            margin-top: 12px;
          }
          .label {
            color: #909399;
            margin-right: 8px;
          }
          .value {
            font-weight: 600;
            color: #303133;
          }
        }
      }
    }
  }
  .withdraw-form {
    .el-form-item__label {
      line-height: 20px;
      padding-bottom: 6px;
    }
  }
  .amount-field {
    display: inline-flex;
    align-items: center;
    .prefix {
      display: flex;
      align-items: center;
      height: 28px;
      padding: 0 8px;
      color: #909399;
      font-size: 12px;
      background: #f5f7fa;
      border: 1px solid #dcdfe6;
      border-right: none;
      border-radius: 4px 0 0 4px;
      box-sizing: border-box;
    }
    .el-input-number .el-input__inner {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      font-size: 15px;
      font-weight: 600;
    }
    .withdraw-all {
      margin-left: 12px;
    }
  }
  .tip {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 12px;
    margin-top: 10px;
    color: #e6a23c;
    background: #fdf6ec;
    border-radius: 4px;
    font-size: 12px;
    i {
      margin-right: 5px;
      line-height: 18px;
    }
    span {
      line-height: 18px;
    }
  }
}
</style>
<style lang="scss" scoped>
.wrapper /deep/ {
  /* switch按钮样式 */
  .switch .el-switch__label {
    position: absolute;
    display: none;
    color: #fff !important;
  }
  /*打开时文字位置设置*/
  .switch .el-switch__label--right {
    z-index: 1;
  }
  /* 调整打开时文字的显示位子 */
  .switch .el-switch__label--right span {
    margin-left: 5px;
    margin-right: 10px;
  }
  /*关闭时文字位置设置*/
  .switch .el-switch__label--left {
    z-index: 1;
  }
  /* 调整关闭时文字的显示位子 */
  .switch .el-switch__label--left span {
    margin-left: 20px;
  }
  /*显示文字*/
  .switch .el-switch__label.is-active {
    display: block;
  }
  /* 调整按钮的宽度 */
  .switch.el-switch .el-switch__core,
  .el-switch .el-switch__label {
    width: 55px !important;
    margin: 0;
  }
}
</style>
